var render = function render(){var _vm=this,_c=_vm._self._c;return _c('requests-table',{attrs:{"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }